import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
// 解决多次点击重复路由报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const scrollBehavior = (to, from, savedPosition) => {
  // 在点击浏览器的“前进/后退”，或者切换导航的时候触发
  // keep-alive 返回缓存页面后记录浏览位置savePosition：会记录滚动条的坐标，点击前进/后退的时候记录值{x:?,y:?}
  if (savedPosition && to.meta.keepAlive && to.meta.isUseCache) {
    return savedPosition
  }
  else {
    const position = {
      x:0,
      y:0
    }
    if (to.hash) {
      position.selector = to.hash
    }
    if (to.matched.some(m => m.meta.scrollToTop)) {
      position.x = 0
      position.y = 0
    }
    // 异步滚动操作
    return new Promise((resolve) => {
     setTimeout(() => {
      resolve({ x: 0, y: 1 });
      return position
     }, 0);
    });
  }
}
/* Router Modules */
import commonRouterMap from "./modules/common";//公共
import manualRouterMap from "./modules/manual";//母子健康手册
import maternalRouterMap from "./modules/maternal";//孕产
import babyRouterMap from "./modules/baby";//儿科
import healthRouterMap from "./modules/health";//健康档案
import archivesRouterMap from "./modules/archives";//建档
import bloodglucoseRouterMap from "./modules/bloodglucose";//血糖
import healthbookRouterMap from "./modules/healthbook";//上报 母子健康手册
// 共有页面
export const constantRouterMap = [  
    {
        path: '/',
        redirect: '/manual/home',
        component: () => import('@/pages/manual/home')
    },
    {
      name: '404',
      path: '*',
      component: () => import('@/pages/common/404')
    },
   {
     name: '查看token',
     path: '/common/token',
     component: () => import('@/pages/common/token')
   },
   {
     name: '设置token',
     path: '/common/settoken',
     component: () => import('@/pages/common/settoken')
   },
   {
      name: '授权',
      path: '/wechatLogin',
      component: () => import('@/pages/common/WechatLogin')
  },
  {
      name: 'canvasposter',
      path: '/common/canvasposter',
      component: () => import('@/pages/common/canvasposter')
  },
]
// 可变页面路由
export const asyncRoutes = [...commonRouterMap,...manualRouterMap, ...maternalRouterMap, ...babyRouterMap,
 ...healthRouterMap,
 ...archivesRouterMap,...bloodglucoseRouterMap,...healthbookRouterMap];
// 全部页面路由
let routesMap = [];
routesMap = [...constantRouterMap, ...asyncRoutes];

const createRouter = () => new VueRouter({
  // mode: 'history',
  scrollBehavior,
  routes: routesMap
})

const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export const routerAll = routesMap
export default router
